module.exports = __webpack_public_path__ + "img/AI识别硬件问题.c07ce194.jpg";